import Page from 'src/apipages/authentication/index';

export default Page;
